
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";
import { disclosureInformationFSDataInfoType, incomeInformationDataInfoType, incomeSummaryFSDataInfoType } from '@/types/Application/FinancialStatement';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})
export default class Form4Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false; 

    govSrc = '';   
    nameofEmployer = '';
    otherDesc = '';
    incomeTypes = [];
    incomeAmounts = {};
    otherProofOfIncome = '';
    hasCorporation = false;   

    totalIncome = 0;
    deduction = {};
    addition = {};
    childSupportFund = 0;
    extraExpenses = {};
    spouseExpenses = {};
   
    mounted(){
        this.dataReady = false;        
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){        
        this.getIncomeInfo();  
        this.getIncomeProofInfo();          
        this.getSummaryInfo();
    } 

    public getIncomeInfo(){    
        
        this.govSrc = '';   
        this.nameofEmployer = '';
        this.otherDesc = '';
        this.incomeTypes = [];
        this.incomeAmounts = {};

        if (this.result?.incomeInformationSurvey) {

            const incomeInfo: incomeInformationDataInfoType = this.result.incomeInformationSurvey;
            this.govSrc = '';
            this.nameofEmployer = '';
            this.otherDesc = '';

            const incomeData = incomeInfo.incomeAmounts;
            for(const incomeType of incomeData) {
                if(incomeType.income){
                    this.incomeTypes.push(incomeType.incomeName);
                    this.incomeAmounts[incomeType.incomeName]=incomeType.monthlyAmount;
                    if(incomeType.incomeName == 'employee'){
                        this.nameofEmployer = incomeInfo.nameOfEmployer?incomeInfo.nameOfEmployer:'';
                    } else if(incomeType.incomeName == 'govAssist'){
                        this.govSrc = incomeInfo.govSource?incomeInfo.govSource:'';
                    } else if(incomeType.incomeName == 'other'){
                        this.otherDesc = incomeInfo.otherDesc?incomeInfo.otherDesc:'';
                    }
                }
                    
            }

        }
    }

    public getIncomeProofInfo(){    
        
        this.otherProofOfIncome = '';
        this.hasCorporation = false;

        if (this.result?.disclosureInformationFSSurvey) {
            const disInfo: disclosureInformationFSDataInfoType = this.result.disclosureInformationFSSurvey;
            this.hasCorporation = disInfo.corporation && disInfo.corporation == 'Yes';
            this.otherProofOfIncome = disInfo.otherIncomeProofDocs?disInfo.otherIncomeProofDocs:'';
        }
    }

    public getSummaryInfo(){ 

        this.totalIncome = 0;
        this.deduction = {};
        this.addition = {};
        this.childSupportFund = 0;
        this.extraExpenses = {};
        this.spouseExpenses = {};  

        let extraExpense = false;
        let spouseSupport = false; 
        
        if(this.result?.financialStatementSurvey){

            const fsInfo = this.result.financialStatementSurvey;
            extraExpense = (fsInfo.childAppExists?fsInfo.childAppExists=='y': false) && fsInfo.situationType.includes("There is a claim for section 7 special or extraordinary expenses");
            spouseSupport = fsInfo.spousalAppExists?fsInfo.spousalAppExists=='y': false;
        }        

        if (this.result?.incomeSummaryFSSurvey) {
            const summaryInfo: incomeSummaryFSDataInfoType = this.result.incomeSummaryFSSurvey;
            
            if(summaryInfo.totalIncome && summaryInfo.totalIncome.length>0){
                this.totalIncome = summaryInfo.totalIncome[0]?.yearlyAmount?summaryInfo.totalIncome[0].yearlyAmount:0;
            }
            
            if(summaryInfo.deduction && summaryInfo.deduction.length>0){
                for(const deduction of summaryInfo.deduction) {
                    if(deduction.lineNumber && deduction.yearlyAmount){                       
                        this.deduction[deduction.lineNumber] = deduction.yearlyAmount;                        
                    }                    
                }
            }

            if(summaryInfo.addition && summaryInfo.addition.length>0){
                for(const addition of summaryInfo.addition) {
                    if(addition.lineNumber && addition.yearlyAmount){                       
                        this.addition[addition.lineNumber] = addition.yearlyAmount;                        
                    }                    
                }
            }

            if(summaryInfo.childSupportFund && summaryInfo.childSupportFund.length>0){
                this.childSupportFund = summaryInfo.childSupportFund[0].yearlyAmount;
            }            

            if(extraExpense && summaryInfo.extraExpenses && summaryInfo.extraExpenses.length>0){
                for(const extraExpense of summaryInfo.extraExpenses) {
                    if(extraExpense.lineNumber && extraExpense.yearlyAmount){                       
                        this.extraExpenses[extraExpense.lineNumber] = extraExpense.yearlyAmount;                        
                    }                    
                }
            }

            if(spouseSupport && summaryInfo.spouseExpenses && summaryInfo.spouseExpenses.length>0){
                for(const spouseExpense of summaryInfo.spouseExpenses) {
                    if(spouseExpense.lineNumber && spouseExpense.yearlyAmount){                       
                        this.spouseExpenses[spouseExpense.lineNumber] = spouseExpense.yearlyAmount;                        
                    }                    
                }
            }
        }   
    }  
 
}
